import { AuthenticationService } from 'src/app/shared/service/auth.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EndpointBase } from './endpoint-base.service';
import { ConfigurationService } from './configuration.service';


@Injectable()
export class AccountEndpoint extends EndpointBase {

  get createUserUrl() { return this.configurations.baseUrl + '/api/account/register'; }
  get changePasswordUrl() { return this.configurations.baseUrl + '/api/Account/users/password/change'; }



  get usersUrl() { return this.configurations.baseUrl + '/api/account/users'; }
  get dealerUrl() { return this.configurations.baseUrl + '/api/account/dealers'; }
  get updateDealerUrl() { return this.configurations.baseUrl + '/api/account/dealerorderupdate'; }
  get userByUserNameUrl() { return this.configurations.baseUrl + '/api/account/users/username'; }
  get currentUserUrl() { return this.configurations.baseUrl + '/api/account/users/me'; }
  get currentUserPreferencesUrl() { return this.configurations.baseUrl + '/api/account/users/me/preferences'; }
  get unblockUserUrl() { return this.configurations.baseUrl + '/api/account/users/unblock'; }
  get rolesUrl() { return this.configurations.baseUrl + '/api/account/roles'; }
  get roleByRoleNameUrl() { return this.configurations.baseUrl + '/api/account/roles/name'; }




  private readonly _verifyMobileUrl: string = "/api/account/verifyphone";
  private readonly _verifyOtpUrl: string = "/api/account/verify";
  private readonly _sentOtpUrl: string = "/api/account/sendotp";
  private readonly _sentresetOtpUrl: string = "/api/account/sendotp";
  private readonly _resetPasswordUrl: string = "/api/account/forgotpassword";
  private readonly _setPasswordUrl: string = "/api/account/";
  get mobileVerifyUrl() { return this.configurations.baseUrl + this._verifyMobileUrl; }
  get sentOtpUrl() { return this.configurations.baseUrl + this._sentOtpUrl; }
  get sentResetOtpUrl() { return this.configurations.baseUrl + this._sentresetOtpUrl; }
  get verifyOtpUrl() { return this.configurations.baseUrl + this._verifyOtpUrl; }
  
  get resetPasswordUrl() { return this.configurations.baseUrl + this._resetPasswordUrl; }
  get setPasswordUrl() { return this.configurations.baseUrl + this._setPasswordUrl; }


  constructor(private configurations: ConfigurationService, http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }


  getPasswordChangeEndpoint<T>(passwordObj: any): Observable<T> {
    return this.http.post<T>(this.changePasswordUrl, JSON.stringify(passwordObj), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPasswordChangeEndpoint(passwordObj));
      }));
  }

  getUserEndpoint<T>(userId?: string): Observable<T> {
    const endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserEndpoint(userId));
      }));
  }

  getDealerEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.dealerUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDealerEndpoint());
      }));
  }

  updateDealerOrderEndpoint<T>(id:string,orderId:number): Observable<T> {
    const endpointUrl = `${this.updateDealerUrl}/${id}/${orderId}` 
    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateDealerOrderEndpoint(id,orderId));
      }));
  }

  getUserByUserNameEndpoint<T>(userName: string): Observable<T> {
    const endpointUrl = `${this.userByUserNameUrl}/${userName}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserByUserNameEndpoint(userName));
      }));
  }


  getUsersEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.usersUrl}/${page}/${pageSize}` : this.usersUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUsersEndpoint(page, pageSize));
      }));
  }


  getNewUserEndpoint<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.createUserUrl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewUserEndpoint(userObject));
      }));
  }

  getUpdateUserEndpoint<T>(userObject: any, userId?: string): Observable<T> {
    const endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.put<T>(endpointUrl, JSON.stringify(userObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateUserEndpoint(userObject, userId));
      }));
  }

  getUnblockUserEndpoint<T>(userId: string): Observable<T> {
    const endpointUrl = `${this.unblockUserUrl}/${userId}`;

    return this.http.put<T>(endpointUrl, null, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUnblockUserEndpoint(userId));
      }));
  }

  getDeleteUserEndpoint<T>(userId: string): Observable<T> {
    const endpointUrl = `${this.usersUrl}/${userId}`;

    return this.http.delete<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteUserEndpoint(userId));
      }));
  }
  getRoleEndpoint<T>(roleId: string): Observable<T> {
    const endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleEndpoint(roleId));
      }));
  }

  getRoleByRoleNameEndpoint<T>(roleName: string): Observable<T> {
    const endpointUrl = `${this.roleByRoleNameUrl}/${roleName}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleByRoleNameEndpoint(roleName));
      }));
  }

  getRolesEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    const endpointUrl = page && pageSize ? `${this.rolesUrl}/${page}/${pageSize}` : this.rolesUrl;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRolesEndpoint(page, pageSize));
      }));
  }

  getNewRoleEndpoint<T>(roleObject: any): Observable<T> {

    return this.http.post<T>(this.rolesUrl, JSON.stringify(roleObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewRoleEndpoint(roleObject));
      }));
  }

  getUpdateRoleEndpoint<T>(roleObject: any, roleId: string): Observable<T> {
    const endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(roleObject), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateRoleEndpoint(roleObject, roleId));
      }));
  }

  getDeleteRoleEndpoint<T>(roleId: string): Observable<T> {
    const endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.delete<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteRoleEndpoint(roleId));
      }));
  }
  
  mobileVerifyEndpoint<T>(mobileObject: any): Observable<any> {
    return this.http.post<T>(this.mobileVerifyUrl, JSON.stringify(mobileObject), this.requestHeaders);
      
}
sentResetOtpEndpoint<T>(mobile: any): Observable<any> {
    let url = `${this.sentResetOtpUrl}/${mobile}`;
    return this.http.get<T>(url, this.requestHeaders);
       
}
sentOtpEndpoint<T>(mobile: any): Observable<any> {
  let url = `${this.sentOtpUrl}/${mobile}`;
  return this.http.get<T>(url, this.requestHeaders);
     
}
verifyOtpEndpoint<T>(mobileObject: any): Observable<any> {
  return this.http.post<T>(this.verifyOtpUrl, JSON.stringify(mobileObject), this.requestHeaders);
     
}
resetPasswordEndpoint<T>(object: any): Observable<any> {
  return this.http.post<T>(this.resetPasswordUrl, JSON.stringify(object), this.requestHeaders);
}
setPasswordEndpoint<T>(object: any,userId:any): Observable<any> {
  return this.http.post<T>(this.setPasswordUrl+`${userId}/password`, JSON.stringify(object), this.requestHeaders);
}
}
